function defaultAction( previous: GenericStateObject ) {
	return previous;
}

export type ReducerShortHandler = ( payload: unknown ) => void;

export type GenericStateObject = {
	[key:string] : any
}

export type ReducerActions = {
	[action: string]: ( previous: GenericStateObject, payload: any ) => GenericStateObject
}

const ACTIONS: ReducerActions = {
	update( previous: GenericStateObject, payload: GenericStateObject ) {
		return {
			...previous,
			...payload,
		};
	},
	replace( previous: GenericStateObject, payload: GenericStateObject ) {
		return payload;
	},
};

export type NextReducerValues = {
	action: string;
	payload: any;
}

export type PreviousReducerValues = {
	[key: string]: any;
}

export type ReducerDispatch<RD = Record<string, ReducerShortHandler>> = RD & {
	( nextReducerValues: NextReducerValues ): ( nextReducerValues: NextReducerValues ) => void;
	update: ReducerShortHandler
	replace: ReducerShortHandler
}

export default function reducer( previous: GenericStateObject, next: NextReducerValues ) {
	const {
		action,
		payload,
	} = next;
	const {
		[ action ]: cta = defaultAction,
	} = ACTIONS;

	return cta( previous, payload );
}
